const DEFAULT_PRICE_FORMAT = '원';

export { DEFAULT_PRICE_FORMAT };
